import { Resizable, ResizableProps } from 're-resizable';

import { merge } from '@/components';

export type PanelProps = ResizableProps;

export const Panel = ({ className, children, ...rest }: PanelProps) => {
  return (
    <Resizable
      className={merge('flex min-h-0 border-r border-gray-200', className)}
      defaultSize={{ width: '15vw' }}
      enable={{ right: true }}
      {...rest}
    >
      {children}
    </Resizable>
  );
};
